import React from "react";
import { NavLink, Navigate, useParams, useSearchParams } from "react-router-dom";
import { FaClipboardList, FaTh } from "react-icons/fa";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import ScoringHub from "../../components/ScoringHub/ScoringHub";
import LaneAssignmentWorkspace from "../../components/ScoringHub/LaneAssignment/LaneAssignmentWorkspace";
import { getScoringUrl } from "../../utility/adminNavigation";
import { useTournamentId, useTournamentSlug } from "../../context/TournamentRouteContext";
import { tournamentPath } from "../../utility/tournamentUrls";
import TournamentSubpageHead from "../../components/SEO/TournamentSubpageHead";

const SCORING_TABS = [
  { id: "scores", label: "Scores", icon: FaClipboardList },
  { id: "lanes", label: "Lanes", icon: FaTh },
];

export default function TournamentScoring() {
  const { tab } = useParams();
  const tournamentId = useTournamentId();
  const tournamentSlug = useTournamentSlug();
  const [searchParams] = useSearchParams();

  if (tab && !SCORING_TABS.some((item) => item.id === tab)) {
    return (
      <Navigate
        to={getScoringUrl(tournamentSlug, "scores", searchParams)}
        replace
      />
    );
  }

  const pageKey =
    tab === "lanes" ? "scoring/lanes" : tab === "scores" ? "scoring/scores" : "scoring";

  const tabSearch = searchParams.toString();
  const tabTo = (id) => {
    const path = getScoringUrl(tournamentSlug, id);
    return tabSearch ? `${path}?${tabSearch}` : path;
  };

  return (
    <div className="space-y-6">
      <TournamentSubpageHead page={pageKey} />
      <div className="flex justify-center mb-3 sm:mb-4 px-4 sm:px-0">
        <Breadcrumb
          items={[
            { label: "Home", path: "/" },
            { label: "Tournaments", path: "/tournaments" },
            {
              label: "Tournament",
              path: tournamentPath(tournamentSlug),
            },
            { label: "Scoring" },
          ]}
        />
      </div>

      <div className="card-board overflow-hidden">
        <div className="bg-brand-charcoal text-brand-cream px-6 py-4">
          <h1 className="font-display font-bold text-xl text-brand-cream tracking-tight">
            Scoring
          </h1>
          <p className="text-sm text-brand-mist mt-1">
            Enter scores and assign lanes.
          </p>
        </div>
        <nav
          className="flex flex-wrap px-2 sm:px-4"
          aria-label="Scoring tabs"
        >
          {SCORING_TABS.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.id}
                to={tabTo(item.id)}
                className={() => {
                  const active =
                    item.id === "lanes" ? tab === "lanes" : !tab || tab === "scores";
                  return `flex items-center gap-2 min-h-11 py-2 px-3 sm:px-4 border-b-2 font-display font-bold text-sm tracking-wide whitespace-nowrap transition-colors duration-200 ${
                    active
                      ? "border-brand-charcoal text-brand-charcoal"
                      : "border-transparent text-brand-muted hover:text-brand-charcoal"
                  }`;
                }}
              >
                <Icon className="w-4 h-4 text-brand-muted" />
                <span>{item.label}</span>
              </NavLink>
            );
          })}
        </nav>
      </div>

      {tab === "lanes" ? <LaneAssignmentWorkspace /> : <ScoringHub hideTitle />}
    </div>
  );
}
